import DrawingComponent from "./components/DrawingComponent/DrawingComponent";
import LocationComponent from "./components/LocationComponent/LocationComponent";
import TableComponent from "./components/TableComponent/TableComponent";
import Table2Component from "./components/Table2Component/Table2Component";
import Table3Component from "./components/Table3Component/Table3Component";
import CameraComponent from "./components/CameraComponent/CameraComponent";
import HomeComponent from "./components/HomeComponent/HomeComponent";
import EditableInput from "./components/EditableInput/EditableInput";

const AppRoutes = [
  {
    path: '/',
    element: <HomeComponent />
  },
  {
    path: 'table',
    element: <TableComponent />
  },
  {
    path: 'table2',
    element: <Table2Component />
  },
  {
    path: 'table3',
    element: <Table3Component />
  },
  {
    path: 'drawing',
    element: <DrawingComponent />
  },
  {
    path: 'location',
    element: <LocationComponent />
  },
  {
    path: 'camera',
    element: <CameraComponent />
  },
  {
    path: 'editableinput',
    element: <EditableInput />
  }
];

export default AppRoutes;
